/**
 * Generated bundle index. Do not edit.
 */

export {Ng2SearchPipeModule,Ng2SearchPipe} from './index';
